import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  readonly sealUrl: string | undefined;
  readonly signatureUrl: string | undefined;
}

export default function SealPreview({ sealUrl, signatureUrl }: Props) {
  if (sealUrl == null) {
    return null;
  }

  return (
    <div>
      <Typography sx={{ mb: 2 }} variant="h6">
        Preview
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', bgcolor: '#fff' }}>
        <Box component="img" sx={{ width: '75%' }} src={sealUrl} alt="Seal" />
        <Box component="img" sx={{ width: '75%' }} src={signatureUrl} alt="Signature" />
      </Box>
    </div>
  );
}
